import { useSelector } from "react-redux";
import { STATE_EXPERIMENT_MAP } from "../../server/utils/get-listing-sorting-experiment-data";
import { STATE_CODES } from "../constants/state-name-constants";
import getMeaningfulExperimentNames from "../utils/statsig-ab-utils/get-meaningful-experiment-names";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";

const EMPTY_OBJ = {};
export const useSortingExperiment = ({source}) => {
    const abExperiment = useSelector((state) => state?.abExperiment || EMPTY_OBJ);
    const isoCode = useSelector((state) => state?.user?.userGeoData?.state?.isoCode) || STATE_CODES.VIC;
    const experimentKey = STATE_EXPERIMENT_MAP[isoCode]?.[source];
    if (!experimentKey) {
        return {
            sortingVariant: EXPERIMENT_TYPE.VARIANT_A,
            currentStateCode: isoCode
        };
    }
    const sortingReducerKey = getMeaningfulExperimentNames(experimentKey);
    const { [sortingReducerKey]: {data: sortingVariant} = {}} = abExperiment || {};
    return {
        sortingVariant: sortingVariant || EXPERIMENT_TYPE.VARIANT_A,
        currentStateCode: isoCode
    };
};
